import appEnvironment from '../app-environment';
import { formatUrl, parseQuery } from 'url-lib';

let _mediaUrl = '';
let _appPath = '';
let _apiPath = '';
let _token = '';

const checkPath = (path) => {
    if (!path) {
        return '';
    }
    if (path.charAt(path.length - 1) === '/') {
        return path.slice(0, -1);
    }
    return path;
};

const init = () => {
    _mediaUrl = checkPath(appEnvironment.getVar('mediaUrl'));
    _appPath = checkPath(appEnvironment.getVar('appPath'));
    _apiPath = checkPath(appEnvironment.getVar('apiPath') || '/api');
    _token = appEnvironment.getVar('token');
};

const _getUrl = (urlPrefix, path, extraQuery = {}) => {
    if (!path) {
        return '';
    }
    let pathToUse = path;

    if (path.charAt(0) !== '/') {
        pathToUse = `/${path}`;
    } else {
        pathToUse = path;
    }
    const query = path.split('?')[1];

    const queryObj = parseQuery(query);

    return formatUrl(`${urlPrefix}${pathToUse}`, [queryObj, extraQuery]);
};

const getAppUrl = (path) => {
    const resultPath = _getUrl(_appPath, path);

    return resultPath;
};

const getBffUrl = (path) => {
    const resultPath = _getUrl('/purchase-flow-webapp/api', path, {
        token: _token,
    });
    return resultPath;
};

const getApiUrl = (path) => {
    const resultPath = _getUrl(_apiPath, path, { token: _token });

    return resultPath;
};

const getMediaUrl = (path) => {
    const resultPath = _getUrl(_mediaUrl, path);

    return resultPath;
};

init();

const ebUrl = {
    getAppUrl,
    getMediaUrl,
    getApiUrl,
    getBffUrl,
    init,
};

if (typeof window !== 'undefined') {
    window.debugEBUrl = ebUrl;
}

export default ebUrl;
